import React from 'react';
import { codeableConceptDisplay } from '@/features/fhir/helpers/fhirpath';
import { Text } from '@react-pdf/renderer';
import ClinicalDocumentLayout, {
  ClinicalDocumentProps,
} from '../ClinicalDocumentLayout';
import { DocumentPanelPrimary } from '../../components/DocumentPanel';
import SignaturePractitioner from '../SignaturePractitioner';

type Props = ClinicalDocumentProps<fhir4.ServiceRequest>;

const DocumentPageEncaminhamento: React.FC<Props> = ({
  resource,
  encounter,
  header,
  photo,
}) => {
  const specialty = React.useMemo(
    () => codeableConceptDisplay(resource, 'code'),
    [resource],
  );

  const reason = React.useMemo(
    () => codeableConceptDisplay(resource, 'reasonCode'),
    [resource],
  );

  return (
    <ClinicalDocumentLayout
      encounter={encounter}
      header={header}
      title="Encaminhamento médico"
      photo={photo}
      footer={
        <SignaturePractitioner
          encounter={encounter}
          style={{ alignSelf: 'center' }}
        />
      }
    >
      <DocumentPanelPrimary
        title="Encaminhar para"
        content={<Text style={{ textAlign: 'center' }}>{specialty}</Text>}
      />

      {reason && (
        <DocumentPanelPrimary wrap title="Indicação" content={reason} />
      )}
    </ClinicalDocumentLayout>
  );
};

export default DocumentPageEncaminhamento;
